import Seo, { SeoProps } from '@allesauto/core/seo';
import { useWhiteLabel } from '@allesauto/core/whiteLabel';
import React, { FC } from 'react';

const SeoContainer: FC<SeoProps> = (props: SeoProps) => {
  const whitelabel = useWhiteLabel();

  const seoProps: SeoProps = {
    ...props,
    whiteLabel: whitelabel,
  };

  return <Seo {...seoProps} />;
};

export default SeoContainer;
